import router from "@/router/index";
import Cookies from "js-cookie";
import i18n from "@/lang";
import {
  generateInitiator,
  generateURL,
  getRequestId,
  handleRequestInterceptor,
  handleResponseErrorsInterceptor,
  handleResponseInterceptor,
  isValidRequest,
} from "./config"

const API = async (
  {
    url,
    data,
    method = "get",
    params = {},
    requestId,
    isURLFull = false,
    requiresAuth = true,
    token = Cookies.get(process.env.VUE_APP_TOKEN_KEY),
    showGlobalAlert = true, // To display trackResponse when handling the errors
    cancelAllPendingRequest = false,
    version = 2,
    blockScreen = false,
    disableDefaultErrorHandlingAt = [],
    initiator = "",
    cancelWhenLeaveInitiator,
    responseType = {
      success: "json",
      failure: "json",
    },
    excludedLogFields = [],
    disableLoggingAt = [],
  },
) => {
  const controller = new AbortController();
  const generatedInitiator = generateInitiator({ initiator })
  const generatedRequestId = getRequestId({
    initiator: generatedInitiator,
    id: requestId,
  })
  if (!isValidRequest({
    requestId,
    url,
  })) {
    return false
  }
  handleRequestInterceptor({
    requestId: generatedRequestId,
    controller,
    blockScreen,
    initiator: generatedInitiator,
    cancelWhenLeaveInitiator,
    cancelAllPendingRequest,
  })

  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "X-CSRF-TOKEN": document.querySelector("meta[name=\"csrf-token\"]")
      ?.getAttribute("content"),
    version,
    source: "boostiny-web",
    clientRoute: router.currentRoute.fullPath,
    bypass_maintenance: Cookies.get("qcpass") || null,
    "Accept-Language": i18n.locale,
    ...(!requiresAuth && { system: process.env.VUE_APP_NAME }),
    ...(!params.file && method.toLowerCase() !== "get" ? { "Content-Type": "application/json" } : {}),
  };

  const mutatedParams = {}

  Object.keys(params).forEach((key) => {
    if (params[key] !== "") {
      mutatedParams[key] = params[key]
    }
  })

  const res = await fetch(generateURL({
    url,
    version,
    params: mutatedParams,
    method,
    isURLFull,
  }), {
    headers,
    method,
    ...(data ? { body: params.file ? data : JSON.stringify(data) } : {}),
    signal: controller.signal,
  })
  const result = await res[res.ok ? responseType.success : responseType.failure]()
  if (res.ok) {
    handleResponseInterceptor({ requestId: generatedRequestId })
    return { data: result }
  }
  const errors = {
    ...result.payload.errors,
    status: res.status,
  }

  handleResponseErrorsInterceptor({
    requestId: generatedRequestId,
    errors,
    showGlobalAlert,
    disableDefaultErrorHandlingAt,
    url,
    params: mutatedParams,
    ...(data && { body: data }),
    excludedLogFields,
    disableLoggingAt,
  })
  throw errors
}

export default API
